var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatYouGet1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_431_10744)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 100,
    height: 100,
    rx: 16,
    fill: "#E8A50F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 84C28.8333 84 27.2633 83.3478 25.9567 82.0433C24.6522 80.7367 24 79.1667 24 77.3333V30.6667C24 28.8333 24.6522 27.2633 25.9567 25.9567C27.2633 24.6522 28.8333 24 30.6667 24H44C45.8333 24 47.4033 24.6522 48.71 25.9567C50.0144 27.2633 50.6667 28.8333 50.6667 30.6667V77.3333C50.6667 79.1667 50.0144 80.7367 48.71 82.0433C47.4033 83.3478 45.8333 84 44 84H30.6667ZM64 47.3333C62.1667 47.3333 60.5978 46.68 59.2933 45.3733C57.9867 44.0689 57.3333 42.5 57.3333 40.6667V30.6667C57.3333 28.8333 57.9867 27.2633 59.2933 25.9567C60.5978 24.6522 62.1667 24 64 24H77.3333C79.1667 24 80.7367 24.6522 82.0433 25.9567C83.3478 27.2633 84 28.8333 84 30.6667V40.6667C84 42.5 83.3478 44.0689 82.0433 45.3733C80.7367 46.68 79.1667 47.3333 77.3333 47.3333H64ZM64 84C62.1667 84 60.5978 83.3478 59.2933 82.0433C57.9867 80.7367 57.3333 79.1667 57.3333 77.3333V60.6667C57.3333 58.8333 57.9867 57.2633 59.2933 55.9567C60.5978 54.6522 62.1667 54 64 54H77.3333C79.1667 54 80.7367 54.6522 82.0433 55.9567C83.3478 57.2633 84 58.8333 84 60.6667V77.3333C84 79.1667 83.3478 80.7367 82.0433 82.0433C80.7367 83.3478 79.1667 84 77.3333 84H64Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_431_10744",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_431_10744"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_431_10744",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatYouGet1);
export default __webpack_public_path__ + "static/media/WhatYouGet1.44106e356420b9e2450a6c361ce8cdf7.svg";
export { ForwardRef as ReactComponent };